import {createContext} from 'react';

import {AuthLayoutProps} from 'layouts';

export type AuthLayoutRouteContextProps = {
    setAuthLayoutProps: (props: Partial<AuthLayoutProps>) => void
}

export const AuthLayoutRouteContext = createContext<AuthLayoutRouteContextProps>({} as AuthLayoutRouteContextProps);